import { lazy } from 'react';

export const PlayerZipCodeForm = lazy(() => import('./PlayerZipCodeForm'));
